import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    position: 'relative',
    '& + $root': {
      marginTop: 16,
      [theme.breakpoints.down('sm')]: {
        marginTop: 8,
      },
    },
  },
});

const Section = ({ className, classes, children }) => (
  <div className={classNames(className, classes.root)}>
    {children}
  </div>
);

Section.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

Section.defaultProps = {
  className: '',
};

export default withStyles(styles)(Section);



// WEBPACK FOOTER //
// ./src/components/common/Section/Section.js